/**
 * Created by Karol Kluska on 12.09.17.
 */

angular
  .module('app')
  .component('offersCart', {
    templateUrl: 'app/components/offers/cart/Cart.html',
    controller: Cart,
    bindings: {
      items: '<',
      maxItems: '<',
      occupancy: '<',
      onSave: '&',
      onDelete: '&'
    }
  });

/** @ngInject */
// eslint-disable-next-line
function Cart($translate, Currency, ConfigHotel, ConfigBookingEngine, PROPERTY_TYPE) {
  var $this = this;
  $this.$translate = $translate;
  $this.Currency = Currency;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.PROPERTY_TYPE = PROPERTY_TYPE;
  $this.propertyType = ConfigHotel.getPropertyType();
}

Cart.prototype = {
  isEnabledHostelView: function () {
    return this.ConfigBookingEngine.isHostelViewEnabled();
  },

  getMaxItems: function () {
    return this.maxItems;
  },

  getItemsCount: function () {
    return this.items.length;
  },

  getPersonsCount: function (itemId) {
    return this.occupancy[itemId].count;
  },

  getPersonTranslation: function (count) {
    var translations = this.getPersonDeclination();

    if (count in translations) {
      return translations[count].replace('%d', count);
    }
    return translations['-1'].replace('%d', count);
  },

  getFormattedPrice: function (price) {
    return this.Currency.getFormattedPrice(price);
  },

  getPersonDeclination: function () {
    return {
      1: this.$translate.instant('offers.cart.ONE_PERSON'),
      2: this.$translate.instant('offers.cart.TWO_TO_FOUR_PEOPLE'),
      3: this.$translate.instant('offers.cart.TWO_TO_FOUR_PEOPLE'),
      4: this.$translate.instant('offers.cart.TWO_TO_FOUR_PEOPLE'),
      '-1': this.$translate.instant('offers.cart.FIVE_AND_MORE_PEOPLE')
    };
  },

  getSelectTranslation: function () {
    switch (this.propertyType) {
      case this.PROPERTY_TYPE.ROOMS:
        return this.$translate.instant('offers.cart.SELECT_ROOM', {
          number: this.getItemsCount() + 1,
          length: this.getMaxItems()
        });
      case this.PROPERTY_TYPE.APARTMENTS:
        return this.$translate.instant('offers.cart.SELECT_APARTMENT', {
          number: this.getItemsCount() + 1,
          length: this.getMaxItems()
        });
      case this.PROPERTY_TYPE.COTTAGES:
        return this.$translate.instant('offers.cart.SELECT_COTTAGE', {
          number: this.getItemsCount() + 1,
          length: this.getMaxItems()
        });
      default:
        return this.$translate.instant('offers.cart.SELECT_ROOM', {
          number: this.getItemsCount() + 1,
          length: this.getMaxItems()
        });
    }
  },

  isFullCart: function () {
    return this.getItemsCount() >= this.getMaxItems();
  },

  showInformationBar: function () {
    return this.isFullCart() === false && this.isEnabledHostelView() === false;
  },

  remove: function (item) {
    this.onDelete({room: item});
  },

  save: function () {
    this.onSave();
  }
};
